import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "row wrap" }, "Current status", -1 /* HOISTED */)
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "q-pl-md q-pt-md col-5" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "text-subtitle1" }, "Equipment Status", -1 /* HOISTED */)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-6 q-mb-sm" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  class: "text-weight-thin q-ml-sm q-mt-sm",
  "data-test": "last-failure-type"
}
const _hoisted_10 = {
  key: 0,
  class: "col-6 q-mb-sm"
}
const _hoisted_11 = {
  key: 0,
  class: "column q-ml-sm"
}
const _hoisted_12 = { class: "text-caption" }
const _hoisted_13 = { class: "text-caption" }
const _hoisted_14 = {
  key: 1,
  class: "q-ml-sm text-caption"
}
const _hoisted_15 = {
  key: 1,
  class: "col-6 q-mb-sm"
}
const _hoisted_16 = {
  key: 2,
  class: "col-6 q-mb-sm"
}
const _hoisted_17 = { class: "col-12 q-mb-sm" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 0,
  class: "col-12 information-type-label"
}
const _hoisted_20 = {
  key: 1,
  class: "col-12 information-type-label"
}
const _hoisted_21 = {
  key: 1,
  class: "row justify-start"
}
const _hoisted_22 = { class: "col-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "Stage 1:", -1 /* HOISTED */)
const _hoisted_24 = { class: "row" }
const _hoisted_25 = {
  key: 0,
  class: "col-4"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "Stage 2:", -1 /* HOISTED */)
const _hoisted_27 = { class: "row" }
const _hoisted_28 = {
  key: 1,
  class: "col-4"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, "Stage 3:", -1 /* HOISTED */)
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "q-pt-md col-7" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "text-subtitle1" }, "Recent alerts")
], -1 /* HOISTED */)
const _hoisted_34 = { class: "col-9 recent-status" }
const _hoisted_35 = { class: "row justify-end alert-pointers" }
const _hoisted_36 = { class: "col-auto q-py-xs q-px-xs" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "s-type" }, "Real", -1 /* HOISTED */)
const _hoisted_38 = { class: "col-auto q-py-xs q-px-xs" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "s-type" }, "False", -1 /* HOISTED */)
const _hoisted_40 = { class: "col-auto q-py-xs q-px-xs" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "s-type" }, "Unknown", -1 /* HOISTED */)
const _hoisted_42 = { class: "col-12" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" New features are in development and will be available in a few weeks. ")
const _hoisted_44 = { class: "alert-carousel-holder" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "row information-type-label q-mt-md q-mb-sm" }, "Last 30 days", -1 /* HOISTED */)
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col q-pr-md alert-block-main" }
const _hoisted_48 = { class: "alert-type text-primary" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Temperature ")
const _hoisted_50 = { class: "text-h5 q-mt-sm q-mb-xs justify-center items-center flex" }
const _hoisted_51 = { class: "q-px-sm" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" 2 ")
const _hoisted_53 = { class: "text-caption text-secondary justify-center items-center flex" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" Last year: ")
const _hoisted_55 = { class: "q-px-xs items-center flex" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" 3 ")
const _hoisted_57 = { class: "col q-pr-md alert-block-main" }
const _hoisted_58 = { class: "alert-type text-primary" }
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" Low pressure ")
const _hoisted_60 = { class: "text-h5 q-mt-sm q-mb-xs justify-center items-center flex" }
const _hoisted_61 = { class: "q-px-sm" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_63 = { class: "q-px-sm" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_65 = { class: "text-caption text-secondary justify-center items-center flex" }
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" Last year: ")
const _hoisted_67 = { class: "q-pr-xs items-center flex" }
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_69 = { class: "q-pr-xs items-center flex" }
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_71 = { class: "col q-pr-md alert-block-main" }
const _hoisted_72 = { class: "alert-type text-primary" }
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" Vibration ")
const _hoisted_74 = { class: "text-h5 q-mt-sm q-mb-xs justify-center items-center flex" }
const _hoisted_75 = { class: "q-px-sm" }
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_77 = { class: "text-caption text-secondary justify-center items-center flex" }
const _hoisted_78 = /*#__PURE__*/_createTextVNode(" Last year: ")
const _hoisted_79 = { class: "q-px-xs items-center flex" }
const _hoisted_80 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_81 = { class: "q-pr-xs items-center flex" }
const _hoisted_82 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_83 = { class: "row" }
const _hoisted_84 = { class: "col q-pr-md alert-block-main" }
const _hoisted_85 = { class: "alert-type text-primary" }
const _hoisted_86 = /*#__PURE__*/_createTextVNode(" Low pressure ")
const _hoisted_87 = { class: "text-h5 q-mt-sm q-mb-xs justify-center items-center flex" }
const _hoisted_88 = { class: "q-px-sm" }
const _hoisted_89 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_90 = { class: "q-px-sm" }
const _hoisted_91 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_92 = { class: "text-caption text-secondary justify-center items-center flex" }
const _hoisted_93 = /*#__PURE__*/_createTextVNode(" Last year: ")
const _hoisted_94 = { class: "q-pr-xs items-center flex" }
const _hoisted_95 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_96 = { class: "q-pr-xs items-center flex" }
const _hoisted_97 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_98 = { class: "col q-pr-md alert-block-main" }
const _hoisted_99 = { class: "alert-type text-primary" }
const _hoisted_100 = /*#__PURE__*/_createTextVNode(" Temperature ")
const _hoisted_101 = { class: "text-h5 q-mt-sm q-mb-xs justify-center items-center flex" }
const _hoisted_102 = { class: "q-px-sm" }
const _hoisted_103 = /*#__PURE__*/_createTextVNode(" 2 ")
const _hoisted_104 = { class: "text-caption text-secondary justify-center items-center flex" }
const _hoisted_105 = /*#__PURE__*/_createTextVNode(" Last year: ")
const _hoisted_106 = { class: "q-px-xs items-center flex" }
const _hoisted_107 = /*#__PURE__*/_createTextVNode(" 3 ")
const _hoisted_108 = { class: "col q-pr-md alert-block-main" }
const _hoisted_109 = { class: "alert-type text-primary" }
const _hoisted_110 = /*#__PURE__*/_createTextVNode(" Vibration ")
const _hoisted_111 = { class: "text-h5 q-mt-sm q-mb-xs justify-center items-center flex" }
const _hoisted_112 = { class: "q-px-sm" }
const _hoisted_113 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_114 = { class: "text-caption text-secondary justify-center items-center flex" }
const _hoisted_115 = /*#__PURE__*/_createTextVNode(" Last year: ")
const _hoisted_116 = { class: "q-px-xs items-center flex" }
const _hoisted_117 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_118 = { class: "q-pr-xs items-center flex" }
const _hoisted_119 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_120 = { class: "row" }
const _hoisted_121 = { class: "col q-pr-md alert-block-main" }
const _hoisted_122 = { class: "alert-type text-primary" }
const _hoisted_123 = /*#__PURE__*/_createTextVNode(" Vibration ")
const _hoisted_124 = { class: "text-h5 q-mt-sm q-mb-xs justify-center items-center flex" }
const _hoisted_125 = { class: "q-px-sm" }
const _hoisted_126 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_127 = { class: "text-caption text-secondary justify-center items-center flex" }
const _hoisted_128 = /*#__PURE__*/_createTextVNode(" Last year: ")
const _hoisted_129 = { class: "q-px-xs items-center flex" }
const _hoisted_130 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_131 = { class: "q-pr-xs items-center flex" }
const _hoisted_132 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_133 = { class: "col q-pr-md alert-block-main" }
const _hoisted_134 = { class: "alert-type text-primary" }
const _hoisted_135 = /*#__PURE__*/_createTextVNode(" Temperature ")
const _hoisted_136 = { class: "text-h5 q-mt-sm q-mb-xs justify-center items-center flex" }
const _hoisted_137 = { class: "q-px-sm" }
const _hoisted_138 = /*#__PURE__*/_createTextVNode(" 2 ")
const _hoisted_139 = { class: "text-caption text-secondary justify-center items-center flex" }
const _hoisted_140 = /*#__PURE__*/_createTextVNode(" Last year: ")
const _hoisted_141 = { class: "q-px-xs items-center flex" }
const _hoisted_142 = /*#__PURE__*/_createTextVNode(" 3 ")
const _hoisted_143 = { class: "col q-pr-md alert-block-main" }
const _hoisted_144 = { class: "alert-type text-primary" }
const _hoisted_145 = /*#__PURE__*/_createTextVNode(" Low pressure ")
const _hoisted_146 = { class: "text-h5 q-mt-sm q-mb-xs justify-center items-center flex" }
const _hoisted_147 = { class: "q-px-sm" }
const _hoisted_148 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_149 = { class: "q-px-sm" }
const _hoisted_150 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_151 = { class: "text-caption text-secondary justify-center items-center flex" }
const _hoisted_152 = /*#__PURE__*/_createTextVNode(" Last year: ")
const _hoisted_153 = { class: "q-pr-xs items-center flex" }
const _hoisted_154 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_155 = { class: "q-pr-xs items-center flex" }
const _hoisted_156 = /*#__PURE__*/_createTextVNode(" 1 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_EquipmentStatusSelector = _resolveComponent("EquipmentStatusSelector")!
  const _component_QualityKpi = _resolveComponent("QualityKpi")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_carousel_slide = _resolveComponent("q-carousel-slide")!
  const _component_q_carousel = _resolveComponent("q-carousel")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_ctx.equipment)
    ? (_openBlock(), _createBlock(_component_q_card, {
        key: 0,
        class: "q-mb-lg current-status-main"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "row justify-between card-title" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_q_separator),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_EquipmentStatusSelector)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_QualityKpi, {
                    "information-type": _ctx.informationType.OIL
                  }, null, 8 /* PROPS */, ["information-type"]),
                  (
                _ctx.equipment.equipmentModel.system === _ctx.equipmentSystem.TRANSFORMERS
              )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.getLastFailureType), 1 /* TEXT */)
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                (
              _ctx.equipment.equipmentModel.system !== _ctx.equipmentSystem.TRANSFORMERS
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_QualityKpi, {
                        "information-type": _ctx.informationType.PERFORMANCE
                      }, null, 8 /* PROPS */, ["information-type"]),
                      (_ctx.equipment.performanceTagValue !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("span", _hoisted_12, _toDisplayString(Number(_ctx.equipment.performanceTagValue)?.toFixed(2)) + "%", 1 /* TEXT */),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.formatDate(_ctx.equipment.lastPerformanceTagValueUpdated)), 1 /* TEXT */)
                          ]))
                        : _createCommentVNode("v-if", true),
                      (_ctx.equipment.performanceTagValue === null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, " No data "))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true),
                (
              _ctx.equipment.equipmentModel.system !== _ctx.equipmentSystem.TRANSFORMERS
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_QualityKpi, {
                        "information-type": _ctx.informationType.VIBRATION
                      }, null, 8 /* PROPS */, ["information-type"])
                    ]))
                  : _createCommentVNode("v-if", true),
                (
              _ctx.equipment.equipmentModel.system === _ctx.equipmentSystem.TRANSFORMERS
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createVNode(_component_QualityKpi, {
                        "information-type": _ctx.informationType.INSULATION
                      }, null, 8 /* PROPS */, ["information-type"])
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_17, [
                  (
                _ctx.getEquipmentDetails.driven === 'Compressor' ||
                _ctx.getEquipmentDetails.driven === 'Pump'
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        (_ctx.getEquipmentDetails.driven === 'Pump')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Mechanical Seal"))
                          : _createCommentVNode("v-if", true),
                        (_ctx.getEquipmentDetails.driven === 'Compressor')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Dry Gas Seal"))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true),
                  (
                _ctx.getEquipmentDetails.driven === 'Compressor' ||
                _ctx.getEquipmentDetails.driven === 'Pump'
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("div", _hoisted_24, [
                            _createVNode(_component_QualityKpi, {
                              "information-type": _ctx.informationType.DRY_GAS_SEAL,
                              "dry-gas-seal-type": _ctx.dryGasSealType.S1DE
                            }, null, 8 /* PROPS */, ["information-type", "dry-gas-seal-type"]),
                            _createVNode(_component_QualityKpi, {
                              "information-type": _ctx.informationType.DRY_GAS_SEAL,
                              "dry-gas-seal-type": _ctx.dryGasSealType.S1NDE
                            }, null, 8 /* PROPS */, ["information-type", "dry-gas-seal-type"])
                          ])
                        ]),
                        (_ctx.getEquipmentDetails.driven !== 'Pump')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _hoisted_26,
                              _createElementVNode("div", _hoisted_27, [
                                _createVNode(_component_QualityKpi, {
                                  "information-type": _ctx.informationType.DRY_GAS_SEAL,
                                  "dry-gas-seal-type": _ctx.dryGasSealType.S2DE
                                }, null, 8 /* PROPS */, ["information-type", "dry-gas-seal-type"]),
                                _createVNode(_component_QualityKpi, {
                                  "information-type": _ctx.informationType.DRY_GAS_SEAL,
                                  "dry-gas-seal-type": _ctx.dryGasSealType.S2NDE
                                }, null, 8 /* PROPS */, ["information-type", "dry-gas-seal-type"])
                              ])
                            ]))
                          : _createCommentVNode("v-if", true),
                        (_ctx.getEquipmentDetails.driven !== 'Pump')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _hoisted_29,
                              _createElementVNode("div", _hoisted_30, [
                                _createVNode(_component_QualityKpi, {
                                  "information-type": _ctx.informationType.DRY_GAS_SEAL,
                                  "dry-gas-seal-type": _ctx.dryGasSealType.S3DE
                                }, null, 8 /* PROPS */, ["information-type", "dry-gas-seal-type"]),
                                _createVNode(_component_QualityKpi, {
                                  "information-type": _ctx.informationType.DRY_GAS_SEAL,
                                  "dry-gas-seal-type": _ctx.dryGasSealType.S3NDE
                                }, null, 8 /* PROPS */, ["information-type", "dry-gas-seal-type"])
                              ])
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_component_q_icon, {
                        name: "o_fact_check",
                        style: {"font-size":"20px","color":"#40a900"}
                      }),
                      _hoisted_37
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_q_icon, {
                        name: "o_cancel",
                        style: {"font-size":"20px","color":"#d10000"}
                      }),
                      _hoisted_39
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createVNode(_component_q_icon, {
                        name: "o_help_outline",
                        style: {"font-size":"20px","color":"#85888a"}
                      }),
                      _hoisted_41
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_q_icon, {
                    name: "o_information",
                    class: "q-mr-sm",
                    size: "xs",
                    style: {"margin":"0"}
                  }),
                  _hoisted_43
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _createVNode(_component_q_carousel, {
                    ref: "carousel",
                    modelValue: _ctx.slide,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.slide) = $event)),
                    "transition-prev": "jump-right",
                    "transition-next": "jump-left",
                    animated: "",
                    infinite: "",
                    "control-type": _ctx.controlType,
                    height: "100px",
                    class: "full-width alert-carousel"
                  }, {
                    default: _withCtx(() => [
                      _createCommentVNode(" :arrows=\"arrows\"\n                swipeable "),
                      _createCommentVNode(" <q-carousel-slide name=\"content-1\" class=\"q-pa-none\"\n                  v-for=\"(slideContent, index) in groupedData\"\n                  :key=\"index\"\n                  :name=\"index\">\n                  <p>{{ groupedData }}</p>\n                  <div class=\"row\">\n                    <div class=\"col q-pr-md alert-block-main\"\n                      v-for=\"(item, itemIndex) in slideContent\"\n                      :key=\"itemIndex\"\n                      :name=\"itemIndex\">  \n                      <q-card-section class=\"alert-block\">\n                        <div class=\"alert-type text-primary\">\n                          <q-icon name=\"o_thermostat\" style=\"font-size: 16px; color: #222B2D\"/>\n                          {{ item.title }}\n                        </div>\n                        <div class=\"text-h5 q-mt-sm q-mb-xs justify-center items-center flex\">\n                          <span class=\"q-px-sm\">\n                            {{ item.slideData.thirty_days[0].a_data }}\n                            <q-icon class=\"alert-img\" name=\"o_fact_check\" style=\"font-size: 20px; color: #40A900\"/>\n                          </span>\n                        </div>\n                        <div class=\"text-caption text-secondary justify-center items-center flex\">\n                          Last year: \n                          <span class=\"q-px-xs items-center flex\">\n                            {{ item.slideData.year[0].a_data }}\n                            <q-icon class=\"alert-last-img\" name=\"o_fact_check\" style=\"font-size: 20px; color: #40A900\"/>\n                          </span>\n                        </div>\n                      </q-card-section>\n                    </div>\n                  </div>\n                </q-carousel-slide> "),
                      _createVNode(_component_q_carousel_slide, {
                        name: "content-1",
                        class: "q-pa-none"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                              _createVNode(_component_q_card_section, { class: "alert-block" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_48, [
                                    _createVNode(_component_q_icon, {
                                      name: "o_thermostat",
                                      style: {"font-size":"16px","color":"#222b2d"}
                                    }),
                                    _hoisted_49
                                  ]),
                                  _createElementVNode("div", _hoisted_50, [
                                    _createElementVNode("span", _hoisted_51, [
                                      _hoisted_52,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-img",
                                        name: "o_fact_check",
                                        style: {"font-size":"20px","color":"#40a900"}
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_53, [
                                    _hoisted_54,
                                    _createElementVNode("span", _hoisted_55, [
                                      _hoisted_56,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-last-img",
                                        name: "o_fact_check",
                                        style: {"font-size":"20px","color":"#40a900"}
                                      })
                                    ])
                                  ])
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _createElementVNode("div", _hoisted_57, [
                              _createVNode(_component_q_card_section, { class: "alert-block" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_58, [
                                    _createVNode(_component_q_icon, {
                                      name: "o_speed",
                                      style: {"font-size":"16px","color":"#222b2d"}
                                    }),
                                    _hoisted_59
                                  ]),
                                  _createElementVNode("div", _hoisted_60, [
                                    _createElementVNode("span", _hoisted_61, [
                                      _hoisted_62,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-img",
                                        name: "o_fact_check",
                                        style: {"font-size":"20px","color":"#40a900"}
                                      })
                                    ]),
                                    _createElementVNode("span", _hoisted_63, [
                                      _hoisted_64,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-img",
                                        name: "o_cancel",
                                        style: {"font-size":"20px","color":"#d10000"}
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_65, [
                                    _hoisted_66,
                                    _createElementVNode("span", _hoisted_67, [
                                      _hoisted_68,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-last-img",
                                        name: "o_fact_check",
                                        style: {"font-size":"20px","color":"#40a900"}
                                      })
                                    ]),
                                    _createElementVNode("span", _hoisted_69, [
                                      _hoisted_70,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-last-img",
                                        name: "o_cancel",
                                        style: {"font-size":"20px","color":"#d10000"}
                                      })
                                    ])
                                  ])
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _createElementVNode("div", _hoisted_71, [
                              _createVNode(_component_q_card_section, { class: "alert-block" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_72, [
                                    _createVNode(_component_q_icon, {
                                      name: "o_vibration",
                                      style: {"font-size":"16px","color":"#222b2d"}
                                    }),
                                    _hoisted_73
                                  ]),
                                  _createElementVNode("div", _hoisted_74, [
                                    _createElementVNode("span", _hoisted_75, [
                                      _hoisted_76,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-img",
                                        name: "o_fact_check",
                                        style: {"font-size":"20px","color":"#40a900"}
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_77, [
                                    _hoisted_78,
                                    _createElementVNode("span", _hoisted_79, [
                                      _hoisted_80,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-last-img",
                                        name: "o_fact_check",
                                        style: {"font-size":"20px","color":"#40a900"}
                                      })
                                    ]),
                                    _createElementVNode("span", _hoisted_81, [
                                      _hoisted_82,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-last-img",
                                        name: "o_cancel",
                                        style: {"font-size":"20px","color":"#d10000"}
                                      })
                                    ])
                                  ])
                                ]),
                                _: 1 /* STABLE */
                              })
                            ])
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_q_carousel_slide, {
                        name: "content-2",
                        class: "q-pa-none"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_83, [
                            _createElementVNode("div", _hoisted_84, [
                              _createVNode(_component_q_card_section, { class: "alert-block" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_85, [
                                    _createVNode(_component_q_icon, {
                                      name: "o_speed",
                                      style: {"font-size":"16px","color":"#222b2d"}
                                    }),
                                    _hoisted_86
                                  ]),
                                  _createElementVNode("div", _hoisted_87, [
                                    _createElementVNode("span", _hoisted_88, [
                                      _hoisted_89,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-img",
                                        name: "o_fact_check",
                                        style: {"font-size":"20px","color":"#40a900"}
                                      })
                                    ]),
                                    _createElementVNode("span", _hoisted_90, [
                                      _hoisted_91,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-img",
                                        name: "o_cancel",
                                        style: {"font-size":"20px","color":"#d10000"}
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_92, [
                                    _hoisted_93,
                                    _createElementVNode("span", _hoisted_94, [
                                      _hoisted_95,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-last-img",
                                        name: "o_fact_check",
                                        style: {"font-size":"20px","color":"#40a900"}
                                      })
                                    ]),
                                    _createElementVNode("span", _hoisted_96, [
                                      _hoisted_97,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-last-img",
                                        name: "o_cancel",
                                        style: {"font-size":"20px","color":"#d10000"}
                                      })
                                    ])
                                  ])
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _createElementVNode("div", _hoisted_98, [
                              _createVNode(_component_q_card_section, { class: "alert-block" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_99, [
                                    _createVNode(_component_q_icon, {
                                      name: "o_thermostat",
                                      style: {"font-size":"16px","color":"#222b2d"}
                                    }),
                                    _hoisted_100
                                  ]),
                                  _createElementVNode("div", _hoisted_101, [
                                    _createElementVNode("span", _hoisted_102, [
                                      _hoisted_103,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-img",
                                        name: "o_fact_check",
                                        style: {"font-size":"20px","color":"#40a900"}
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_104, [
                                    _hoisted_105,
                                    _createElementVNode("span", _hoisted_106, [
                                      _hoisted_107,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-last-img",
                                        name: "o_fact_check",
                                        style: {"font-size":"20px","color":"#40a900"}
                                      })
                                    ])
                                  ])
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _createElementVNode("div", _hoisted_108, [
                              _createVNode(_component_q_card_section, { class: "alert-block" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_109, [
                                    _createVNode(_component_q_icon, {
                                      name: "o_vibration",
                                      style: {"font-size":"16px","color":"#222b2d"}
                                    }),
                                    _hoisted_110
                                  ]),
                                  _createElementVNode("div", _hoisted_111, [
                                    _createElementVNode("span", _hoisted_112, [
                                      _hoisted_113,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-img",
                                        name: "o_fact_check",
                                        style: {"font-size":"20px","color":"#40a900"}
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_114, [
                                    _hoisted_115,
                                    _createElementVNode("span", _hoisted_116, [
                                      _hoisted_117,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-last-img",
                                        name: "o_fact_check",
                                        style: {"font-size":"20px","color":"#40a900"}
                                      })
                                    ]),
                                    _createElementVNode("span", _hoisted_118, [
                                      _hoisted_119,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-last-img",
                                        name: "o_cancel",
                                        style: {"font-size":"20px","color":"#d10000"}
                                      })
                                    ])
                                  ])
                                ]),
                                _: 1 /* STABLE */
                              })
                            ])
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_q_carousel_slide, {
                        name: "content-3",
                        class: "q-pa-none"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_120, [
                            _createElementVNode("div", _hoisted_121, [
                              _createVNode(_component_q_card_section, { class: "alert-block" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_122, [
                                    _createVNode(_component_q_icon, {
                                      name: "o_vibration",
                                      style: {"font-size":"16px","color":"#222b2d"}
                                    }),
                                    _hoisted_123
                                  ]),
                                  _createElementVNode("div", _hoisted_124, [
                                    _createElementVNode("span", _hoisted_125, [
                                      _hoisted_126,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-img",
                                        name: "o_fact_check",
                                        style: {"font-size":"20px","color":"#40a900"}
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_127, [
                                    _hoisted_128,
                                    _createElementVNode("span", _hoisted_129, [
                                      _hoisted_130,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-last-img",
                                        name: "o_fact_check",
                                        style: {"font-size":"20px","color":"#40a900"}
                                      })
                                    ]),
                                    _createElementVNode("span", _hoisted_131, [
                                      _hoisted_132,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-last-img",
                                        name: "o_cancel",
                                        style: {"font-size":"20px","color":"#d10000"}
                                      })
                                    ])
                                  ])
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _createElementVNode("div", _hoisted_133, [
                              _createVNode(_component_q_card_section, { class: "alert-block" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_134, [
                                    _createVNode(_component_q_icon, {
                                      name: "o_thermostat",
                                      style: {"font-size":"16px","color":"#222b2d"}
                                    }),
                                    _hoisted_135
                                  ]),
                                  _createElementVNode("div", _hoisted_136, [
                                    _createElementVNode("span", _hoisted_137, [
                                      _hoisted_138,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-img",
                                        name: "o_fact_check",
                                        style: {"font-size":"20px","color":"#40a900"}
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_139, [
                                    _hoisted_140,
                                    _createElementVNode("span", _hoisted_141, [
                                      _hoisted_142,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-last-img",
                                        name: "o_fact_check",
                                        style: {"font-size":"20px","color":"#40a900"}
                                      })
                                    ])
                                  ])
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _createElementVNode("div", _hoisted_143, [
                              _createVNode(_component_q_card_section, { class: "alert-block" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_144, [
                                    _createVNode(_component_q_icon, {
                                      name: "o_speed",
                                      style: {"font-size":"16px","color":"#222b2d"}
                                    }),
                                    _hoisted_145
                                  ]),
                                  _createElementVNode("div", _hoisted_146, [
                                    _createElementVNode("span", _hoisted_147, [
                                      _hoisted_148,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-img",
                                        name: "o_fact_check",
                                        style: {"font-size":"20px","color":"#40a900"}
                                      })
                                    ]),
                                    _createElementVNode("span", _hoisted_149, [
                                      _hoisted_150,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-img",
                                        name: "o_cancel",
                                        style: {"font-size":"20px","color":"#d10000"}
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_151, [
                                    _hoisted_152,
                                    _createElementVNode("span", _hoisted_153, [
                                      _hoisted_154,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-last-img",
                                        name: "o_fact_check",
                                        style: {"font-size":"20px","color":"#40a900"}
                                      })
                                    ]),
                                    _createElementVNode("span", _hoisted_155, [
                                      _hoisted_156,
                                      _createVNode(_component_q_icon, {
                                        class: "alert-last-img",
                                        name: "o_cancel",
                                        style: {"font-size":"20px","color":"#d10000"}
                                      })
                                    ])
                                  ])
                                ]),
                                _: 1 /* STABLE */
                              })
                            ])
                          ])
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["modelValue", "control-type"])
                ])
              ])
            ])
          ])
        ]),
        _: 1 /* STABLE */
      }))
    : _createCommentVNode("v-if", true)
}